import React from 'react';
import { get } from 'lodash';
import { PauseTypography } from '../../../../components/PauseTypography';
import { PauseButton } from '../../../../components/PauseButton';

export const OverdueCard = ({
  onOpenCustomerPortal = () => null,
}: {
  onOpenCustomerPortal: () => any
}) => (
  <div css={(theme) => ({
    display: 'grid',
    gridAutoFlow: 'columns',
    gridTemplateColumns: '4fr 1fr',
    alignItems: 'center',
    background: get(theme, 'palette.pause.background.medium'),
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    gridGap: theme.spacing(4),
  })}
  >
    <div>
      <PauseTypography variant="caption" color="error.main">
        Your last invoice is overdue
      </PauseTypography>
      <PauseTypography
        css={(theme) => ({
          marginTop: theme.spacing(1),
        })}
        color="pause.primary.medium"
      >
        Renew your payment details or pay the invoice to continue using Pause.
      </PauseTypography>
    </div>
    <div>
      <PauseButton onClick={onOpenCustomerPortal}>
        Renew
      </PauseButton>
    </div>
  </div>
);
